import { processAnalyticsHistory as processAnalyticsHistoryDiagram } from '@process-advisor/process-miner/processMiner/processMiner';


export type Props = {
    type?: string;
    variant?: number,
    activity?: number,
    from?: number,
    to?: number,
    discovery_rule_id?: number,
    discovery_rule_type?: string,
    source?: string
}

export const processAnalyticsHistory = ({
    type, variant, activity, from, to, discovery_rule_id, discovery_rule_type, source
}: Props) => processAnalyticsHistoryDiagram({type, variant, activity, from, to, discovery_rule_id, discovery_rule_type, source});
